module.exports = __webpack_public_path__ + "img/flomsoneutkast.f689c006.jpg";